import request from "@/utils/request";

export function hospitalVerification(data) {
  return request({
    url: "PrevalenceRate/HospitalVerification",
    method: "post",
    data,
  });
}

export function getPersonCaseTableByGuid(data) {
  return request({
    url: "PrevalenceRate/GetPersonCaseTableByGuid",
    method: "post",
    data,
  });
}

export function savePersonCaseTable(data) {
  return request({
    url: "PrevalenceRate/SavePersonCaseTable",
    method: "post",
    data,
  });
}

export function getDeptData(data) {
  return request({
    url: "PrevalenceRate/GetDeptData",
    method: "post",
    data,
  });
}

export function addDeptData(data) {
  return request({
    url: "PrevalenceRate/AddDeptData",
    method: "post",
    data,
  });
}

export function editDeptData(data) {
  return request({
    url: "PrevalenceRate/EditDeptData",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/prevalenceRate.js